import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "brand" }

import useDynamicProductListing from '@/composables/useDynamicProductListing';
import useMeta from '@/composables/useMeta';
import useContext from '@/composables/useContext';

import ScrollToTopButton from '@/components/ScrollToTopButton.vue';
import BrandBreacrumbs from '@/components/Brand/BrandBreacrumbs.vue';
import BrandPageHeader from '@/components/Brand/BrandPageHeader.vue';
import ProductListingBlocks from '@/components/Category/ProductListingBlocks.vue';
import ProductListingFacetsSort from '@/components/Category/ProductListingFacetsSort.vue';
import ProductListing from '@/components/Category/ProductListing.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Brand',
  setup(__props) {

const { page } = useContext();

useMeta();
useDynamicProductListing();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ScrollToTopButton, { triggerDistanceFromTop: 200 }),
    _createVNode(BrandBreacrumbs),
    _createVNode(BrandPageHeader),
    _createVNode(ProductListingBlocks, {
      blocks: _unref(page)?.topBlocks
    }, null, 8, ["blocks"]),
    _createVNode(ProductListingFacetsSort),
    _createVNode(ProductListing),
    _createVNode(ProductListingBlocks, {
      blocks: _unref(page)?.bottomBlocks
    }, null, 8, ["blocks"])
  ]))
}
}

})